import MilestonesAdapter from './base';

export default class MilestoneSet extends MilestonesAdapter {
  modelNamePlural = 'milestonesets';
}
